export default "__VITE_ASSET__b6JNAWvV__"